import { apiSlice } from "../../app/api/apiSlice";


export const loanSummaryApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getLoanSummary: builder.query({
			query: ({ loanId, selectedOrganization, userDetails }) => ({
				url: `/api/v1/pipeline/${loanId}`,

			}),
		}),
	}),
});

export const { useGetLoanSummaryQuery, useLazyGetLoanSummaryQuery } =
	loanSummaryApiSlice;
